import { Cell as ExcelCell } from 'exceljs';

export const customizeSummaryCell = (cell: ExcelCell) => {
    const { workbook } = cell;
    const workSheet = workbook.getWorksheet('Main');
    workSheet.getRow(Number(cell.row)).height = 0;
    workSheet.getRow(Number(cell.row)).hidden = true;
  };
  